






































































import { Component, Vue } from 'vue-property-decorator'
import * as echarts from 'echarts'
import { DateFormat2,DateFormat } from '@/utils/date/DateUtil'
import { SumPlatformTotalData,QueryCurrentShop,SumPlatformDataReport,QueryShopOrderReportList, QueryCurrentShopRegistMerchant } from '@/api'
import defaullShopLogo from '@/assets/img/img.jpg'
import { PriceFormat } from '@/utils/tyepconvert'

@Component({
  components: {
  },
})
export default class SimpleIndex extends Vue {

  private show = false

  private orderStatusData = {
    waitPayQty: 0,
    waitConfirmQty: 0,
    waitShippedQty: 0,
    waitRefundQty: 0,
    shippedQty: 0
  }

  private platformReportData = {
    finishAmount: 0,
    finishOrderQty: 0,
    pv: 0,
    sendMungBeanQty: 0,
    usedMungBeanQty: 0,
    sendContributionQty: 0,
    usedContributionQty: 0,
    sendEnergyQty: 0,
    usedEnergyQty: 0,
  }

   private platformTotalData = {
    totalPv: 0,
    historyTotalPv: 0,
    totalMungBeanQty: 0,
    totalContributionQty: 0,
    totalEnergyQty: 0,
  }

  private timeQuery:any = {
    startTime :null,
    endTime:null
  }

  private timeChangeQuery:any = {
    startTime :null,
    endTime:null
  }

  private selectedDays = 1
  private days = 7

  private nowTime = null

   private get auditStatusTag(){
    switch(this.shop.auditStatus){
      case 1:
        return '标签四'
      case 2:
        return 'success'
      case 3:
        return 'danger'
      default:
        return ''
    }
  }

  private get statusTag(){
    switch(this.shop.status){
      case 0:
        return 'danger'
      case 1:
        return 'success'
      default:
        return ''
    }
  }


  public async created() {
    const date = new Date();
    this.timeQuery.startTime = DateFormat2(date)
    this.timeQuery.endTime = DateFormat2(date)
    const startDate = new Date();
    startDate.setDate(startDate.getDate()-7)
    this.timeChangeQuery.startTime = DateFormat2(startDate)
    this.timeChangeQuery.endTime = DateFormat2(new Date())
    // this.loadPlatformDataReport()

    // SumPlatformTotalData().then(res=>{
    //   this.platformTotalData=res;
    // })
  }

  public async dateClick(data :number){
    this.selectedDays = data;
    if(data === 7){
      const date = new Date();
      date.setDate(date.getDate()-7)
      this.timeQuery.startTime = DateFormat2(date)
      this.timeQuery.endTime = DateFormat2(new Date)
    }else if(data === 1){
      const date = new Date();
      this.timeQuery.startTime = DateFormat2(date)
      this.timeQuery.endTime = DateFormat2(date)
    }else{
      const date = new Date();
      date.setDate(date.getDate()-30)
      this.timeQuery.startTime = DateFormat2(date)
      this.timeQuery.endTime = DateFormat2(new Date)
    }
    this.loadPlatformDataReport()


  }

  public async dateChangeClick(data :number){
    this.days = data;
    if(data === 7){
      const date = new Date();
      date.setDate(date.getDate()-7)
      this.timeChangeQuery.startTime = DateFormat2(date)
      this.timeChangeQuery.endTime = DateFormat2(new Date)
    }else if(data === 15){
      const date = new Date();
      date.setDate(date.getDate()-15)
      this.timeChangeQuery.startTime = DateFormat2(date)
      this.timeChangeQuery.endTime = DateFormat2(new Date)
    }else{
      const date = new Date();
      date.setDate(date.getDate()-30)
      this.timeChangeQuery.startTime = DateFormat2(date)
      this.timeChangeQuery.endTime = DateFormat2(new Date)
    }
    this.loadShopReportDataList()


  }

  private loadPlatformDataReport(){
    SumPlatformDataReport(this.timeQuery).then(res=>{
      if(res.pv){
        res.pv = (res.pv/100).toFixed(2)
      }
      if(res.finishAmount){
        res.finishAmount = (res.finishAmount/100).toFixed(2)
      }
      this.platformReportData=res;
    })
  }

   private loadShopReportDataList(){
    this.loadShopCarts()
  }



  public activated(){
    this.loadShopInfo()
    this.loadShopCarts()
  }

  public beforeDestroy(){
    window.removeEventListener('resize',this.shopEchartResize)
  }

  // 加载店铺信息
  private shop:any = {shopWealth:{}}
  private loadShopInfo(){
    QueryCurrentShop().then(res=>{
      this.shop = res
    })
  }
  private get shopLogo(){
    if(this.shop && this.shop.logo){
      return this.shop.logo+'?x-oss-process=image/resize,w_128,limit_0'
    }

    return defaullShopLogo
  }

  // 加载echarts
  private shopEchart: any

  private async loadShopCarts(){

    // 店铺统计图表
    const ec = document.getElementById("shopCarts")
    if(ec == null){
      return
    }
    let echart = this.shopEchart
    if(!echart){
      echart = echarts.init(ec)
    }

    // const res = await QueryShopOrderReportList(this.timeChangeQuery)
    const res: any[] = []
    res.forEach((e: any) => {
      e.payAmount = PriceFormat(e.payAmount)
      e.refundAmount = PriceFormat(e.refundAmount)
    });
    const salesChartData = res
    const xAxisData = salesChartData.map((e:any)=>e.countDate)
    console.log(xAxisData)
    const data = salesChartData
    // const xAxisData = this.initXAxisData()
    // const data = xAxisData.map(e=>{
    //   const ss = salesChartData.filter((s:any)=>s.countDate == e)
    //   if(ss.length > 0){
    //     return ss[0]
    //   }
    //   return {countDate:e,payAmount:0,refundAmount:0,payOrderQty:0,refundOrderQty:0}

    // })



    const option = {
        grid:{
          top: '60px',
          bottom: '30px',
          left: '45px',
          right: '20px',
        },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xAxisData,

          axisLabel: {
              interale: 0,
              rotate: 0, //设置日期显示样式（倾斜度）
              formatter: function (value: any) {//在这里写你需要的时间格式
                var t_date = new Date(value);
                return [ t_date.getMonth() + 1, t_date.getDate()].join('-')
                // + " " + [t_date.getHours(), t_date.getMinutes()].join(':'); 时分
              }
            }
        },
        yAxis: {

        },
        legend:{show:true},
        dataZoom: {
          // 缩放
          start: salesChartData.length > 120? 80: 0,
          type: 'inside'
        },
        series: [
          {
            type: 'line',
            name: '成交金额',
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: 'countDate',
              // 将 "product" 列映射到 Y 轴。
              y: 'payAmount'
            },
          },
          {
            type: 'line',
            name: '成交单数',
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: 'countDate',
              // 将 "product" 列映射到 Y 轴。
              y: 'payOrderQty'
            }
          },
          {
            type: 'line',
            name: '总PV',
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: 'countDate',
              // 将 "product" 列映射到 Y 轴。
              y: 'payOrderQty'
            }
          },
          {
            type: 'line',
            name: '能量值',
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: 'countDate',
              // 将 "product" 列映射到 Y 轴。
              y: 'payOrderQty'
            }
          },
          {
            type: 'line',
            name: '贡献值',
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: 'countDate',
              // 将 "product" 列映射到 Y 轴。
              y: 'payOrderQty'
            }
          },

        ],
        dataset: {
          source: data
        }
      }


    echart.setOption(option)
    this.shopEchart = echart

    window.addEventListener('resize', this.shopEchartResize)
  }

  private shopEchartResize(){
    console.log('res')
    if(this.shopEchart){
      this.shopEchart.resize()
    }
  }



  private initXAxisData(){
    const data: Array<string> = []

    for(let i = 30 ; i >=0 ; i--){
      const nd = new Date()
      nd.setDate(nd.getDate()-i);
      data.push(DateFormat2(nd))
    }

    return data;
  }

  // 签署协议，获取协议连接，并跳转
  private xieyiHander(){
    QueryCurrentShopRegistMerchant({}).then(res=>{
      if(res.agreementSignurl){
        window.open(res.agreementSignurl, '_blank')
      } else {
        this.$message.warning("签署协议获取失败")
      }
    })
  }

}
